export default {
  actualSetpoint: 'Aktueller Sollwert',
  actualValue: 'Aktueller Wert',
  copySetpointsFromRecipe: 'Sollwerte aus Rezept übernehmen',
};
